import * as React from "react";
import Component from "../../AbstractComponent";
import Formatter from "../../../Localization/Formatter";

import IconButton from '@material-ui/core/IconButton';

export class AbstractPane extends Component {

  constructor(public props) {
    super(props);
  }


  public render() {
    const { entities } = this.props;


    return (
      <div className="abstract-pane"
        style={{
          padding: "10px 20px 0 65px",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "rgba(0, 0, 0, 0.05)"
        }}
      >
        {
          this.props.title && (
            <div style={{marginBottom: "18px"}}>{this.props.title}</div>
          )
          }
        <div>
          {entities && entities.map(entity => {
            let createdDisplayName;
            if(entity?.nameOfEntity === "Contract"){
              const rentTemplate = entity && entity.chargeTemplates.length > 0 && entity.chargeTemplates.find(chargeTemplate => chargeTemplate.type.label === "Basic_rent");
              const rentTemplateDisplayName = rentTemplate ? `${this.formatter.formatNumber(rentTemplate.amount, rentTemplate.currency)} ${Formatter.checkTranslationType(this.trans(rentTemplate?.type?.label), rentTemplate?.repeatPeriod?.label, rentTemplate?.type?.system)},` : "";
              createdDisplayName = entity ? `${rentTemplateDisplayName} ${this.formatter.formatDate(entity.firstDate)} - ${entity.endDate ? this.formatter.formatDate(entity.endDate) : this.trans("no-end-date")}` : "";
            }

            if(!!entity){
              return (
                <div style={{display: "flex", justifyContent: "flex-start", alignItems: "flex-end", marginBottom: "10px", position: "relative" as "relative"}}>
                  <div
                    style={{display: "flex", alignItems: "center", justifyContent: "center", position: "absolute" as "absolute", left: "-40px", bottom: "-4px"}}
                  >
                    <div
                      className={`icon icon-ic-${entity.nameForUrl}`}
                      style={{color: "#b2b2b2"}}>
                    </div>
                  </div>
                  <div style={{display: "flex", flexDirection: "column", color: "rgba(0, 0, 0, 0.6)"}}>
                    <div style={{fontSize: "12px", marginBottom: "5px"}}>
                      {entity.nameForUrl === "person" ? this.trans("tenant") : entity.nameOfEntity}
                    </div>
                    <div style={{fontSize: "14px", color: "black"}}>
                      {createdDisplayName || entity.displayName}
                    </div>
                  </div>
                  <div
                    style={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "8px", position: "relative" as "relative", top: "18px"}}
                    onClick={() => this.redirect(`/app/${entity.nameForUrl}/update/${entity.id}`)}
                  >
                    <IconButton className="icon-button-wrapper" style={{cursor: "pointer"}}>
                      <div
                        className="icon icon-ic-open-in-new"
                      >
                      </div>
                    </IconButton>
                  </div>
                </div>
              )
            }
          })
        }   
        </div>
      </div>
    );
  }
}
